module.exports = __webpack_public_path__ + "static/media/carcere-san-tommaso.5a2ce05c.svg";